import Img1 from 'assets/innvolight/multimodality-technology/img1.png'
import Img2 from 'assets/innvolight/multimodality-technology/img2.png'
import Img3 from 'assets/innvolight/multimodality-technology/img3.png'

export default function MultimodalityTechnology() {
  return (
    <div className="relative h-auto bg-center bg-slate-50">
      <div className="relative z-10 max-w-[1440px] w-full mx-auto h-full py-20  px-4  md:px-10 lg:px-16 2xl:px-0">
        <div className="flex flex-col w-full gap-10">
          <div className="flex justify-start w-full">
            <h3 className="text-2xl font-bold text-left text-black sm:text-2xl md:text-3xl gsap-opacity-trans-appear">
              <span className="text-orange">Multimodality</span> Technology
            </h3>
          </div>
          <div className="flex flex-col w-full max-w-5xl gap-10 mx-auto">
            <div className="flex flex-col items-center justify-center gap-2 gsap-opacity-trans-appear">
              <div className="w-full max-w-2xl p-2 border-2">
                <img
                  src={Img1}
                  className="object-contain w-full h-full"
                  alt=""
                />
              </div>
              <h4 className="text-sm font-bold text-center sm:text-lg md:text-base lg:text-2xl">
                Index of <span className="text-orange">Plaque Attenuation</span>{' '}
                (IPA)
              </h4>
            </div>
            <div className="flex flex-col items-center justify-center gap-2 gsap-opacity-trans-appear">
              <div className="w-full max-w-3xl p-2 border-2">
                <img
                  src={Img2}
                  className="object-contain w-full h-full"
                  alt=""
                />
              </div>
              <h4 className="text-sm font-bold text-center sm:text-lg md:text-base lg:text-2xl">
                Intelligent{' '}
                <span className="text-orange">Calcium Assessment</span> (ICA)
              </h4>
            </div>
            <div className="flex flex-col items-center justify-center gap-2 gsap-opacity-trans-appear">
              <div className="w-full max-w-5xl p-2 border-2">
                <img
                  src={Img3}
                  className="object-contain w-full h-full"
                  alt=""
                />
              </div>
              <h4 className="text-sm font-bold text-center sm:text-lg md:text-base lg:text-2xl">
                Virtual Flow Ratio (VFR)
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
